import { render, staticRenderFns } from "./RewardPointHeader.vue?vue&type=template&id=0f0541b9&"
import script from "./RewardPointHeader.vue?vue&type=script&lang=js&"
export * from "./RewardPointHeader.vue?vue&type=script&lang=js&"
import style0 from "./RewardPointHeader.vue?vue&type=style&index=0&id=0f0541b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports